import AuthGuard from "@/components/AuthGuard";
import { Module, PATH_PERMISSION_DENIED } from "@/constants";
import { useIsActiveContractor } from "@/modules/account/hooks/useIsActiveContractor";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

export default function ContractorPlannedHoursRouteGuard({
  children,
}: PropsWithChildren) {
  const isActiveContractor = useIsActiveContractor();
  const permissions = useModulePermissions(Module.Contractors);

  return (
    <AuthGuard>
      {isActiveContractor && permissions.contractors_planned_hours_read ? (
        children
      ) : (
        <Navigate to={PATH_PERMISSION_DENIED} replace />
      )}
    </AuthGuard>
  );
}
